import { down } from "styled-breakpoints";
import styled from "styled-components";

type Props = {
  disableRightPadding?: boolean
  disableLeftPadding?: boolean
}

const Section = styled.section<Props>`
  padding: 6rem ${props => props.disableRightPadding ? '0' : '7vw'} 6rem ${props => props.disableLeftPadding ? '0' : '7vw'};
  ${down('sm')}{
    padding: 3rem ${props => props.disableRightPadding ? '0' : '7vw'} 3rem ${props => props.disableLeftPadding ? '0' : '7vw'}; 
  }
`

export default Section